import { http, HttpResponse } from 'msw'

import { allTechnicians } from 'app/mocks/data/users/technicians'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersTechnicianApi } from 'app/utils/users/technician'

import { TechniciansRequest } from 'app/types/users/technician'

export const getAllTechnicians = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.technicians.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managersIdsFilter = searchParams.get(
            searchParametersTechnicianApi.MANAGERS,
        )

        const lastNameFilter = searchParams.get(
            searchParametersTechnicianApi.LAST_NAME,
        )

        const firstNameFilter = searchParams.get(
            searchParametersTechnicianApi.FIRST_NAME,
        )

        const cardNumberFilter = searchParams.get(
            searchParametersTechnicianApi.CARD_NUMBER,
        )

        const mifareCodeFilter = searchParams.get(
            searchParametersTechnicianApi.MIFARE_CODE,
        )

        let allTechniciansFiltered = allTechnicians

        // Manager filter
        if (managersIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managersIdsFilter)

            allTechniciansFiltered = allTechniciansFiltered.filter(
                (technician) =>
                    technician.client.some((manager) =>
                        managerIdsSplit.includes(manager.id),
                    ),
            )
        }

        // Last name filter
        if (lastNameFilter) {
            allTechniciansFiltered = allTechniciansFiltered.filter(
                (technician) =>
                    technician.last_name
                        .toLowerCase()
                        .includes(lastNameFilter.toLowerCase()),
            )
        }

        // First name filter
        if (firstNameFilter) {
            allTechniciansFiltered = allTechniciansFiltered.filter(
                (technician) =>
                    technician.first_name
                        .toLowerCase()
                        .includes(firstNameFilter.toLowerCase()),
            )
        }

        // Card number filter
        if (cardNumberFilter) {
            allTechniciansFiltered = allTechniciansFiltered.filter(
                (technician) =>
                    technician.card_id
                        .toLowerCase()
                        .includes(cardNumberFilter.toLowerCase()),
            )
        }

        // MIFARE code filter
        if (mifareCodeFilter) {
            allTechniciansFiltered = allTechniciansFiltered.filter(
                (technician) =>
                    technician.serial_number.includes(mifareCodeFilter),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allTechniciansFiltered.length > limit
                ? offset + limit
                : allTechniciansFiltered.length

        const results = allTechniciansFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allTechniciansFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<TechniciansRequest>({
            next,
            results,
        })
    },
)
